module.exports = __webpack_public_path__ + "img/wreckingBallCoffeeRoasters.cc963813.jpg";